function handleHover(event: MouseEvent) {
    const button = event.currentTarget as HTMLElement
    const rect = button.getBoundingClientRect()
    const width = rect.width
    const height = rect.height
    const centerX = rect.left + width / 2

    const offsetXFromLeft = ((event.clientX - rect.left) / width) * 100
    const offsetYFromTop = ((event.clientY - rect.top) / height) * 100
    const offsetXFromCenter = Math.abs(((event.clientX - centerX) / (width / 2)) * 50)

    const circle = button.querySelector<HTMLElement>('.button__circle')
    if (!circle) return

    circle.style.left = `${offsetXFromLeft.toFixed(1)}%`
    circle.style.top = `${offsetYFromTop.toFixed(1)}%`
    circle.style.width = `${115 + Number(offsetXFromCenter.toFixed(1)) * 2}%`
}

document.querySelectorAll<HTMLElement>('[data-btn-hover]').forEach((button) => {
    button.addEventListener('mouseenter', handleHover)
    button.addEventListener('mouseleave', handleHover)
})
